import { render, staticRenderFns } from "./odds-group.vue?vue&type=template&id=2eaefef2&"
import script from "./odds-group.vue?vue&type=script&lang=js&"
export * from "./odds-group.vue?vue&type=script&lang=js&"
import style0 from "./odds-group.vue?vue&type=style&index=0&id=2eaefef2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports